// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PegOverridesListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Per-franchise peg overrides — GET /ai/credits/peg-overrides. Full-gated.
 *
 * Without ?franquia_id the rows are the ones currently IN FORCE across every
 * franchise (the staff roster). With ?franquia_id they are that franchise's
 * full history, closed windows included, newest first.
 */
import type { AiCredits_PegOverrideRow } from './AiCredits_PegOverrideRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PegOverridesListResponseDados {
rows: AiCredits_PegOverrideRow[]
}

export type AiCredits_PegOverridesListResponse = ApiResponse<AiCredits_PegOverridesListResponseDados>;

registerResponseContract('AiCredits_PegOverridesListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'number',  required: true },
      franquia_id: { type: 'number',  required: true },
      peg_usd:     { type: 'string',  required: true },
      valid_from:  { type: 'string',  required: true },
      valid_to:    { type: 'string',  required: false },
      created_by:  { type: 'string',  required: false },
      reason:      { type: 'string',  required: false },
    },
  },
})
